import React from "react";
import SignUp from "../components/SignUp";

export default function Login() {
  return (
    <>
      <SignUp></SignUp>
    </>
  );
}
